import {commit, make} from 'vuex-pathify'

// initial state
function defaultState() {
    return {
        gender:null,

        firstname:null,
        lastname:null,

        email:null,
        optin_terms_conditions:null,
        optin_privacy:null,
        optin_iban:null,

        street:null,
        street_number:null,
        street_box_number:null,
        zip_code:null,
        city:null,
        district:null,

        phone:null,

        iban:null,
        payment_type:null,
        codice_fiscale: null,

        password:null,
        password_confirmation:null,

        source:null,

        cookbook_sended:false,

        gift: null,
    }
}

const state = defaultState();

// getters
const getters = {
    defaultState : (state) => {
        return defaultState();
    }
}

// actions
const actions = {}

// mutations
const mutations = {
    ...make.mutations(state),
    resetState(state) {
        const initial = defaultState();
        let keysState = _.keys(state);
        let keysInitial = _.keys(initial);
        let keysDifference = _.difference(keysState,keysInitial);
        Object.keys(initial).forEach(key => {
            state[key] = initial[key]
        })
        _.forEach(keysDifference,item=>{_.unset(state,item)})
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
